import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { Box, Typography, Paper, Container, Button, CircularProgress } from '@mui/material';
import Header from '../components/Header';
import ReactPlayer from 'react-player';

function HeroDetails() {
    const [heroDetails, setHeroDetails] = useState(null);
    const { id } = useParams();

    useEffect(() => {
        axios.get(`https://overfast-api.tekrop.fr/heroes/${id}?locale=fr-fr`)
            .then((res) => {
                setHeroDetails(res.data);
            })
            .catch(error => console.error('Error fetching hero details:', error));
    }, [id]);

    if (!heroDetails) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <CircularProgress />
            </Box>
        );
    }

    return (
        <>
            <Header />

            <Container maxWidth="md" sx={{ mt: 4 }}>
                <Paper elevation={3} sx={{ p: 4 }}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 4 }}>
                        <img src={heroDetails.portrait} alt={heroDetails.name} style={{ width: '250px', borderRadius: '10px' }} />
                        <Typography variant="h4" sx={{ mt: 2, fontFamily: 'Oswald, sans-serif' }}>{heroDetails.name}</Typography>
                        <Typography variant="subtitle1" sx={{ mt: 1, fontFamily: 'Oswald, sans-serif', textTransform: 'uppercase' }}>{heroDetails.role}</Typography>
                        <Typography sx={{ mt: 1, mb: 2, fontFamily: 'Oswald, sans-serif' }}>{heroDetails.location}</Typography>
                    </Box>

                    <Typography sx={{ fontFamily: 'Kanit, sans-serif' }} variant="h6">Description :</Typography>
                    <Typography sx={{ fontFamily: 'Oswald, sans-serif' }} paragraph>{heroDetails.description}</Typography>

                    <Typography sx={{ fontFamily: 'Kanit, sans-serif' }} variant="h6">Histoire :</Typography>
                    {heroDetails.story.chapters.map((chapter, index) => (
                        <Box key={index} sx={{ mt: 2 }}>
                            <Typography sx={{ fontFamily: 'Kanit, sans-serif', fontWeight: '400', fontSize: '1.3rem' }} variant="subtitle1">{chapter.title}</Typography>
                            <Typography sx={{ fontFamily: 'Oswald, sans-serif' }} paragraph>{chapter.content}</Typography>
                            <img src={chapter.picture} alt={"Image de " + chapter.title} style={{ width: '100%', borderRadius: '10px', mt: 1 }} />
                        </Box>
                    ))}

                    {heroDetails.story.media.link && (
                        <Box sx={{ mt: 4 }}>
                            <ReactPlayer url={heroDetails.story.media.link} width="100%" controls={true} pipe={true} />
                        </Box>
                    )}
                </Paper>
            </Container>
        </>
    );
}

export default HeroDetails;
